import { InstagramIcon, MagnetiqIcon, TwitterIcon } from "components/atoms/Icon";
import { Link } from "react-router-dom";
import { MAGNETIQ_LINKS } from "../../../constants";

function Footer() {
  return (
    <div
      className="flex flex-col items-center justify-between
     px-4 font-sora text-sm font-semibold text-white md:flex-row"
    >
      <div className="flex flex-col items-center space-x-5 md:flex-row ">
        <MagnetiqIcon />
        <div className="flex space-x-5">
          <a href={MAGNETIQ_LINKS.TWITTER_LINK} target="_blank" rel="noreferrer">
            <div className=" flex cursor-pointer items-center space-x-2">
              <TwitterIcon />
              <div>TWITTER</div>
            </div>
          </a>
          <a href={MAGNETIQ_LINKS.INSTAGRAM_LINK} target="_blank" rel="noreferrer">
            <div className=" flex cursor-pointer items-center space-x-2">
              <InstagramIcon />
              <div>INSTAGRAM</div>
            </div>
          </a>
        </div>
      </div>
      <div className="flex space-x-5 ">
        <Link to={MAGNETIQ_LINKS.TERMS_OF_SERVICE_LINK} target="_blank">
          <div>TERMS OF SERVICE</div>
        </Link>
        <Link to={MAGNETIQ_LINKS.PRIVACY_POLICY_LINK} target="_blank">
          <div>PRIVACY</div>
        </Link>
        {/* <Link to="/help">
          <div>HELP</div>
        </Link> */}
      </div>
    </div>
  );
}
export default Footer;
